<template>
  <base-layout :aside-type="asideType">
    <template slot="sidenav">
      <Sidenav/>
    </template>

    <template slot="main">
      <router-view></router-view>
    </template>
  </base-layout>
</template>

<script>
import BaseLayout from '@/components/layouts/BaseLayout'
import Sidenav from '@/components/SidenavHome'

export default {
  name: 'home-base',
  components: {
    BaseLayout,
    Sidenav
  },
  data () {
    return {
      asideType: 'home'
    }
  }
}
</script>
